module.exports = __webpack_public_path__ + "static/media/justanothermoviesapp.7f6f9718.png";